export function initGallery() {
  var track = document.getElementById('mj-gallery-track');
  if (!track) return;

  var cards = Array.from(track.querySelectorAll('.mj-creation-detail__gallery-card'));
  var prevBtn = document.getElementById('mj-gallery-prev');
  var nextBtn = document.getElementById('mj-gallery-next');
  var modal = document.getElementById('mj-gallery-modal');
  var modalImg = document.getElementById('mj-gallery-modal-img');
  var modalBody = document.getElementById('mj-gallery-modal-body');
  var modalClose = document.getElementById('mj-gallery-modal-x');
  var modalBackdrop = document.getElementById('mj-gallery-modal-close');
  var modalPrev = document.getElementById('mj-modal-prev');
  var modalNext = document.getElementById('mj-modal-next');
  var currentIdx = 0;

  var srcs = cards.map(function (c) { return c.getAttribute('data-src'); });

  function scrollStep() { return track.offsetWidth * 0.65; }

  if (prevBtn) prevBtn.addEventListener('click', function () {
    track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
  });
  if (nextBtn) nextBtn.addEventListener('click', function () {
    track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
  });

  function updateTrackNav() {
    if (!prevBtn) return;
    var atStart = track.scrollLeft < 10;
    var atEnd = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 10;
    prevBtn.style.opacity = atStart ? '0' : '1';
    prevBtn.style.pointerEvents = atStart ? 'none' : 'auto';
    nextBtn.style.opacity = atEnd ? '0' : '1';
    nextBtn.style.pointerEvents = atEnd ? 'none' : 'auto';
  }
  track.addEventListener('scroll', updateTrackNav);
  window.addEventListener('resize', updateTrackNav);
  window.addEventListener('load', updateTrackNav);
  updateTrackNav();

  function openModal(idx) {
    currentIdx = idx;
    showImage(idx);
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  function showImage(idx) {
    currentIdx = idx;
    modalImg.src = srcs[idx];
    modalImg.alt = cards[idx].querySelector('img').alt;
    modalBody.scrollTop = 0;
  }
  function navigate(dir) {
    var next = currentIdx + dir;
    if (next < 0) next = srcs.length - 1;
    if (next >= srcs.length) next = 0;
    showImage(next);
  }

  cards.forEach(function (card) {
    card.addEventListener('click', function () {
      openModal(parseInt(card.getAttribute('data-index'), 10));
    });
  });

  if (modalClose) modalClose.addEventListener('click', closeModal);
  if (modalBackdrop) modalBackdrop.addEventListener('click', closeModal);
  if (modalPrev) modalPrev.addEventListener('click', function () { navigate(-1); });
  if (modalNext) modalNext.addEventListener('click', function () { navigate(1); });

  document.addEventListener('keydown', function (e) {
    if (modal.getAttribute('aria-hidden') !== 'false') return;
    if (e.key === 'Escape') closeModal();
    if (e.key === 'ArrowLeft') navigate(-1);
    if (e.key === 'ArrowRight') navigate(1);
  });
}
